import React, { useState } from 'react'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import { usePersonalStore } from '../../../stores/personalInfo'
import { ActivityIndicator, ScrollView, View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import Canvas from '../../canvas'
import CustomButton from '../../shared/button/Button'
import Toast from 'react-native-toast-message'
import moment from 'moment'

const CellPhonePolicy = ({ navigation, route }) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,

    } = params

    const [hasDrawn, setHasDrawn] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postgrenadepolicy } = useFormsStore()


    const data = {
        entityId: personalstore.personalData?.entityId,
        essUserKey: intializeStore.initializeData.userkey,
        essObKey: essUserOnBoardingKey,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        completeOnline: true,
        sign: signatureDataURL

    }
    const handlesubmit = async () => {
        const response: any = await postgrenadepolicy(data)
        if (response?.success === true) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'Grocery Basket Cellphone Policy'}
                    />
                </View>
            </View>
            <ScrollView>
                <Card
                    style={{
                        fontFamily: "Arial, sans-serif",
                        lineHeight: "1.6",
                        fontSize: '11px'
                    }}
                >

                    <p style={{ fontWeight: "bold" }}>
                        Grocery Basket of Grenada, Inc.<br />Employee Cell Phone Policy<br />TO: All Employees<br />FROM: Sammy Brasher, Manager<br />DATE: 4/24/2024</p>

                    <p><strong>Purpose:</strong>This policy outlines rules for cell phone use to maintain productivity and minimize distractions at work.</p>

                    <p><strong>Policy:</strong></p>
                    <div style={{ marginLeft: "20px" }}><p><strong>1. Cell Phone Ban:</strong><br />• Personal cell phones are prohibited from being used during work hours and in the store.</p>
                        <p><strong>2. For Emergencies:</strong><br />• Use company communication devices or seek supervisor approval for personal phone use in emergencies.</p>
                        <p><strong>3. Monitoring and Compliance:</strong><br />• Managers will enforce the policy; non-compliance may result in disciplinary actions, including termination for repeated violations.</p></div>

                    <p><strong>Consequences:</strong></p>
                    <p style={{ marginLeft: "20px" }}><strong>• First Offense:</strong> Verbal warning.</p>
                    <p style={{ marginLeft: "20px" }}><strong>• Second Offense:</strong> Written warning and one-day suspension without pay.</p>
                    <p style={{ marginLeft: "20px" }}><strong>• Further Offenses:</strong> Possible termination.</p>

                    <p><strong>Responsibility:</strong></p>
                    <p style={{ marginLeft: "20px" }}>• Employees must adhere to this policy; managers are responsible for enforcement.</p>
                    <p style={{ marginLeft: "20px" }}>• Direct questions or concerns to Sammy Brasher or your supervisor.</p>

                    <p><strong>Acknowledgment:</strong></p>
                    <p style={{ marginLeft: "20px" }}>• By working at Grocery Basket of Grenada, Inc., you agree to follow this policy. Violations could lead to disciplinary actions up to termination.</p>


                    <p><strong>Employee Name:</strong><span style={{ textDecoration: "underline" }}>{personalstore?.personalData?.firstName} {personalstore?.personalData?.middleInitial} {personalstore?.personalData?.lastName} </span></p>
                    <div>
                        <table
                            style={{
                                borderCollapse: 'collapse',
                                width: '100%',
                                marginTop: '30px'
                            }}
                        >
                            <tbody>

                                <tr style={{ width: "100%" }}>
                                    <td style={{ width: "70%", fontSize: "11px", display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: '5px' }}>
                                            <strong>Employee Signature: </strong>
                                        </p>
                                        <p>
                                            <Canvas setSignatureDataURL={setSignatureDataURL} setHasDrawn={setHasDrawn} hasDrawn={hasDrawn} />
                                        </p>
                                    </td>


                                </tr>
                            </tbody>
                        </table>


                    </div>
                    <p><strong>Date:</strong> <span style={{ textDecoration: "underline" }}>{moment().format("MM/DD/YYYY")}</span></p>


                    <p><strong>Sammy Brasher</strong><br />Manager, Grocery Basket of Grenada, Inc.</p>

                </Card>
                {loading ? (
                    <ActivityIndicator />
                ) : (
                    <View
                        style={{
                            marginTop: 10,
                            marginBottom: 25,
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() =>
                                navigation.navigate('OnboardingForms')
                            }
                        />
                        <CustomButton
                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handlesubmit}
                        />
                    </View>
                )}

            </ScrollView>

        </>
    )
}

export default CellPhonePolicy
